module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image9b.f79e128c.jpg";